import { Trans, useLingui } from '@lingui/react/macro';

import config from '@/config';
import Button from '@/design_system/Button';
import Dialog from '@/design_system/Dialog';
import { Footer, FooterButtons } from '@/design_system/Footer';
import Paragraph from '@/design_system/Typography/Paragraph';
import IconReceipt from '@/icons/Receipt.svg';
import { RequestWithRelations } from '@/models/request';
import useViewPort from '@/utils/useViewport';

export const PrintDropOffReceiptModal = ({
  request,
  onClose,
}: {
  request: RequestWithRelations;
  onClose: () => void;
}) => {
  return (
    <Dialog
      isOpen
      title={
        <Trans id="requests.new.drop-off-receipt-modal.title">Print a drop-off receipt?</Trans>
      }
      onOpenChange={() => onClose()}
    >
      <main>
        <Paragraph>
          <Trans id="requests.new.drop-off-receipt-modal.content">
            <b>Your request has been successfully created and saved as a draft.</b>
            <br />
            An email has been sent to the client with a link to the request.
            <br />
            Do you also want to print a drop-off receipt?
          </Trans>
        </Paragraph>
      </main>
      <Footer>
        <FooterButtons>
          <Button
            variant="secondary"
            size="medium"
            onPress={() => onClose()}
            dataTrackingId="requests.new.drop-off-receipt-modal.actions.no"
          >
            <Trans id="requests.new.drop-off-receipt-modal.actions.no">No thanks</Trans>
          </Button>
          <Button
            variant="primary"
            size="medium"
            href={config.apiUrl + `/requests/${request.id}/drop-off-receipt?preview=1`}
            download
            onPress={() => {
              onClose();
            }}
            dataTrackingId="requests.new.drop-off-receipt-modal.actions.print"
          >
            <IconReceipt />
            <Trans id="requests.new.drop-off-receipt-modal.actions.print">
              Print drop-off receipt
            </Trans>
          </Button>
        </FooterButtons>
      </Footer>
    </Dialog>
  );
};

export const PrintDropOffReceiptButton = ({ request }: { request: RequestWithRelations }) => {
  const { t } = useLingui();
  const { isMobile } = useViewPort();

  return (
    <Button
      variant="secondary"
      size="medium"
      href={config.apiUrl + `/requests/${request.id}/drop-off-receipt?preview=1`}
      download
      style={isMobile ? { flex: 1 } : undefined}
      ariaLabel={
        isMobile
          ? t({
              id: 'request.edit.actions.print-drop-off-receipt',
              message: 'Print drop-off receipt',
            })
          : undefined
      }
    >
      <IconReceipt />
      {!isMobile && (
        <Trans id="request.edit.actions.print-drop-off-receipt">Print drop-off receipt</Trans>
      )}
    </Button>
  );
};
